import {
  CandidateCardProfessional,
  CandidateCardStartup,
  CandidateCardSpotlight,
  CandidateCardLight,
  CandidateCardSnow,
} from "@/ui/components";
import { THEME_TYPES } from "@lib/enums";

export const CANDIDATE_CARD_VARIANTS = [
  { type: THEME_TYPES.PROFESSIONAL, label: "Professional", Component: CandidateCardProfessional },
  { type: THEME_TYPES.STARTUP, label: "Startup", Component: CandidateCardStartup },
  { type: THEME_TYPES.SPOTLIGHT, label: "Spotlight", Component: CandidateCardSpotlight },
  { type: THEME_TYPES.LIGHT, label: "Light", Component: CandidateCardLight },
  { type: THEME_TYPES.SNOW, label: "Snow", Component: CandidateCardSnow },
];

export function getCandidateCardComponent(type) {
  const match = CANDIDATE_CARD_VARIANTS.find((v) => v.type === type);
  return match ? match.Component : CandidateCardProfessional;
}
